module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAYAAADQzyn5AAAABHNCSVQICAgIfAhkiAAAAQhJREFUWEfF2UsOwyAMBNCi3o4LdNHzddEL5HZVKldNlCgQ/Jlx2MDuyQgkBpdb0pim6SFUrfUtc8lwBS2lvMSa5/kpOB3eoPd/kR/BqXADFZsLn6G0rR6hlMOlQeGwFoXCFhQGW1EI7EHDsBcNwRHUDUdRF4xAzTAKNcFIVA2jURXMQIcwCz2FmWgXZqNNOAM9wFnoDs5EVzgb/cFXoNfCol9R9ZoksvFdhMnED9kpC2+Gtgy8mxbZ+GlMZeLDfMzChzDrnqtgBq6G0bgJRuJmGIW7YATuhqN4CI7gYdiLQ2APDoOtOBS24HBYi1NgDU6DRzgV7uDc/2pBl7F5TOS1Bra4rJdmyBcmcNQqmOw2jgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/pC/prev.png
// module id = SHVX
// module chunks = 1